<template>
  <div class="tour-registration">
    <div class="container">
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <div class="row mt-5">
          <div class="col-md-6 offset-md-3">
            <div class="card shadow-xs no-border radius10">
              <div class="card-body">
                <h1 class="h3 text-center mt-3 mb-4">Tour Registration</h1>
                <b-form @submit.stop.prevent="registerTour" class="primary px-md-5">
                  <b-form-group label="First Name" label-for="firstName">
                    <b-form-input id="firstName" v-model="firstName" required placeholder="Enter your first name"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Last Name" label-for="lastName">
                    <b-form-input id="lastName" v-model="lastName" required placeholder="Enter your last name"></b-form-input>
                  </b-form-group>

                  <b-form-group label="Email Address" label-for="email">
                    <b-form-input id="email" type="email" v-model="email" required placeholder="Enter your email"></b-form-input>
                  </b-form-group>

                  <b-button type="submit" variant="success" size="lg" block :disabled="isLoading">
                    Submit Request
                  </b-button>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from '@/firebase'

export default {
  name: 'TourRegistration',
  props: {
    startDate: String,
    endDate: String,
    tourID: String
  },
  data () {
    return {
      isLoading: false,
      firstName: '',
      lastName: '',
      email: ''
    }
  },
  methods: {
    registerTour () {
      this.isLoading = true

      // Assuming you have a 'tourRequests' collection in your Firestore
      const tourRequest = {
        tourID: this.tourID,
        startDate: this.startDate,
        endDate: this.endDate,
        user: {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        },
        timestamp: firebase.firestore.FieldValue.serverTimestamp() // Add a timestamp for when the request was made
      }

      firebase.firestore().collection('tourRequests').add(tourRequest)
        .then(() => {
          this.isLoading = false
          // Handle success (e.g., show a confirmation message)
          alert('Tour request submitted successfully!')
        })
        .catch(error => {
          this.isLoading = false
          // Handle error
          console.error('Error submitting tour request: ', error)
        })
    }
  },
  mounted () {
    document.body.classList.add('bg-forest')
  }
}
</script>
